import 'angular:locale/data:en-US';
import 'zone.js';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "en-US";
